module.exports = __webpack_public_path__ + "static/media/info_hover.133d1d7b.svg";